<template>
  <!--콘텐츠 영역-->
  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item">
      <div class="tit">
        <h3 class="fNS-EB">윤리강령</h3>
        <span
          >공정하고 투명한 경영을 위해 <br />
          윤리규범을 제정하여 임직원들의 <br />
          행동 기준으로 적용하고 있습니다.</span
        >
      </div>
      <div class="txt">
        <h6 class="pdb50">윤리규범</h6>
        <dl class="type01">
          <dt>목&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;적 :</dt>
          <dd>
            이 윤리 규범은 (이하 ‘규범’) 윤리헌장을 준수하기 위한 올바른
            의사결정과<br />
            윤리적 판단기준을 임직원에게 제공함을 목적으로 한다.
          </dd>
        </dl>
        <p class="b_bt"></p>

        <dl class="type01">
          <dt>적용대상 :</dt>
          <dd>
            규범은 페럼인프라(‘회사‘)에 속한 모든 임직원(계약직 포함)에 대하여
            적용한다.
          </dd>
        </dl>
      </div>
    </div>
    <div class="item">
      <div class="txt">
        <section id="accordion">
          <div>
            <input type="checkbox" id="check-1" checked />
            <label for="check-1">
              <h5 class="fNS-B">회사의 기본방침</h5>
            </label>
            <article>
              <p>
                1. 임직원은 명예와 자부심을 갖고 상사와 동료, 부하직원의 인격을
                존중하고 성적희롱이나 비윤리적 행위를 하지 않는다.
              </p>

              <p>
                2.본인은 업무를 공평무사하게 처리하고 거짓, 변명 등 기회주의적
                언사나 행동을 하지 않고 사규에 따라 소신 있게 업무처리 하고 그
                결과에 대해서는 책임을 진다.
              </p>

              <p>
                3. 본인은 특정 개인이나 부서의 이익을 위해 허위 보고나 정보를
                은폐하지 않는다.
              </p>

              <p>
                4.본인은 회사의 물적, 지적재산권, 영업비밀 등 정보를 보호하며
                이를 사적인 목적으로 사용하지 아니한다.
              </p>

              <p>
                5.본인은 업무와 관련하여 횡령, 배임, 금품수수 등 일체의 부정을
                하지 않으며 부득이하게 정부가 정한 사회통념상의 수준 이상의
                금품을 수수하였을 경우는 윤리위원회에 보고한다. 또한 업무 수행
                시 회사와 개인의 이해가 상충할 시 회사의 이익 을 우선으로
                생각하고 행동한다.
              </p>

              <p>
                6. 본인은 주인의식을 갖고 회사의 금품을 아껴 쓰고, 사치, 낭비,
                허례허식, 과음, 과소비, 도박 등 비도덕적 행위를 지양하고
                근검절약을 생활화한다.
              </p>

              <p>
                7.본인은 세계수준의 경쟁력을 갖추기 위해 끊임없이 자기계발을
                하고 상하 간에 존경하고 따르며 교육하고 상호간의 잘못 된 점을
                반드시 지적하고 고친다.
              </p>
            </article>
          </div>
        </section>

        <p class="pdt50">윤리경영 위반 신고 센터 담당자 : 정경오 , 이메일 주소 kyungoh.jung@dongkuk.com</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "Ethics.vue"
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub01/Ethics.vue